import {
    CONFIRM_BOOKING,
    CONFIRM_BOOKING_SUCCESS,
    CONFIRM_BOOKING_FAILED,
    CLEAR_BOOKING
} from "../store/types";
import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { formatBookingObject } from '../other/sharedFunctions';
import {
    notifyDriversForNewBooking,
    recordBookingDispatchMeta,
} from '../other/dispatchLog';
import { get, push } from "firebase/database";
import { logBookingCreated } from "../other/facebookAnalytics";

export const clearBooking = () => (dispatch) => {
    dispatch({
        type: CLEAR_BOOKING,
        payload: null,
    });
}

export const addBooking = (bookingData) => async (dispatch) => {

    const   {
        bookingRef,
        settingsRef,
    } = firebase;

    dispatch({
        type: CONFIRM_BOOKING,
        payload: bookingData,
    });

    const settingsdata = await get(settingsRef);
    const settings = settingsdata.val();

    let data = await formatBookingObject(bookingData, settings);
    const language = store.getState().languagedata.defaultLanguage;

    push(bookingRef, data).then(async (res) => {
        var bookingKey = res.key;
        const bookingWithId = {
            ...data,
            id: bookingKey,
            booking_id: bookingKey
        };

        try {
            await recordBookingDispatchMeta(bookingKey, data, settings, bookingData);
            if (bookingData.requestedDrivers || bookingData.preRequestedDrivers) {
                await notifyDriversForNewBooking(bookingKey, bookingData, language);
            }
        } catch (logErr) {
            console.warn("dispatchLog:", logErr);
        }

        logBookingCreated(bookingWithId);

        dispatch({
            type: CONFIRM_BOOKING_SUCCESS,
            payload: {
                booking_id:bookingKey,
                mainData: bookingWithId
            }
        });
    }).catch(error => {
        dispatch({
            type: CONFIRM_BOOKING_FAILED,
            payload: error.code + ": " + error.message,
        });
    });
};
